/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import { BankAccountActivitiesWithdrawalReserve200ResponseAppliedBy } from './bank-account-activities-withdrawal-reserve200-response-applied-by';

/**
 * 
 * @export
 * @interface BankAccountActivitiesWithdrawalReserve200Response
 */
export interface BankAccountActivitiesWithdrawalReserve200Response {
    /**
     * 
     * @type {string}
     * @memberof BankAccountActivitiesWithdrawalReserve200Response
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof BankAccountActivitiesWithdrawalReserve200Response
     */
    'organizationId': string;
    /**
     * 
     * @type {string}
     * @memberof BankAccountActivitiesWithdrawalReserve200Response
     */
    'organizationName': string;
    /**
     * 
     * @type {string}
     * @memberof BankAccountActivitiesWithdrawalReserve200Response
     */
    'type': BankAccountActivitiesWithdrawalReserve200ResponseTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof BankAccountActivitiesWithdrawalReserve200Response
     */
    'status': BankAccountActivitiesWithdrawalReserve200ResponseStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof BankAccountActivitiesWithdrawalReserve200Response
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof BankAccountActivitiesWithdrawalReserve200Response
     */
    'supplierName': string;
    /**
     * 
     * @type {number}
     * @memberof BankAccountActivitiesWithdrawalReserve200Response
     */
    'amount': number;
    /**
     * 
     * @type {number}
     * @memberof BankAccountActivitiesWithdrawalReserve200Response
     */
    'pointAmount': number | null;
    /**
     * 
     * @type {number}
     * @memberof BankAccountActivitiesWithdrawalReserve200Response
     */
    'balance': number | null;
    /**
     * 
     * @type {number}
     * @memberof BankAccountActivitiesWithdrawalReserve200Response
     */
    'pointBalance': number | null;
    /**
     * 
     * @type {boolean}
     * @memberof BankAccountActivitiesWithdrawalReserve200Response
     */
    'isConfirmed': boolean;
    /**
     * 
     * @type {string}
     * @memberof BankAccountActivitiesWithdrawalReserve200Response
     */
    'appliedAt': string | null;
    /**
     * 
     * @type {BankAccountActivitiesWithdrawalReserve200ResponseAppliedBy}
     * @memberof BankAccountActivitiesWithdrawalReserve200Response
     */
    'appliedBy': BankAccountActivitiesWithdrawalReserve200ResponseAppliedBy;
    /**
     * 
     * @type {string}
     * @memberof BankAccountActivitiesWithdrawalReserve200Response
     */
    'executedAt': string | null;
}

export const BankAccountActivitiesWithdrawalReserve200ResponseTypeEnum = {
    payBill: 'PAY_BILL',
    deposit: 'DEPOSIT',
    withdrawal: 'WITHDRAWAL',
    reward: 'REWARD',
    usageFee: 'USAGE_FEE',
    point: 'POINT',
    cardPoint: 'CARD_POINT',
    campaignPoint: 'CAMPAIGN_POINT',
    card: 'CARD',
    depositFromGuaranteeMoney: 'DEPOSIT_FROM_GUARANTEE_MONEY',
    withdrawalToGuaranteeMoney: 'WITHDRAWAL_TO_GUARANTEE_MONEY',
    serviceCharge: 'SERVICE_CHARGE'
} as const;

export type BankAccountActivitiesWithdrawalReserve200ResponseTypeEnum = typeof BankAccountActivitiesWithdrawalReserve200ResponseTypeEnum[keyof typeof BankAccountActivitiesWithdrawalReserve200ResponseTypeEnum];
export const BankAccountActivitiesWithdrawalReserve200ResponseStatusEnum = {
    reserved: 'RESERVED',
    requestingExternalAccountTransfer: 'REQUESTING_EXTERNAL_ACCOUNT_TRANSFER',
    completed: 'COMPLETED',
    insufficientBalance: 'INSUFFICIENT_BALANCE',
    uploaded: 'UPLOADED',
    readCompleted: 'READ_COMPLETED',
    awaitingApproval: 'AWAITING_APPROVAL',
    approved: 'APPROVED',
    transferCompleted: 'TRANSFER_COMPLETED',
    readError: 'READ_ERROR',
    transferFailed: 'TRANSFER_FAILED',
    approvalExpired: 'APPROVAL_EXPIRED',
    approvalRejected: 'APPROVAL_REJECTED',
    otherError: 'OTHER_ERROR',
    pending: 'PENDING'
} as const;

export type BankAccountActivitiesWithdrawalReserve200ResponseStatusEnum = typeof BankAccountActivitiesWithdrawalReserve200ResponseStatusEnum[keyof typeof BankAccountActivitiesWithdrawalReserve200ResponseStatusEnum];


